import { createActions } from 'redux-actions'

export const {
  cmsJobs: {
    load: loadCmsJobs,
    loadSuccess: loadCmsJobsSuccess,
    loadFailure: loadCmsJobsFailure
  }
} = createActions({
  CMS_JOBS: {
    LOAD: (searchParams) => searchParams,
    LOAD_SUCCESS: [(results) => results, (payload, { resultSize }) => ({ resultSize })],
    LOAD_FAILURE: message => ({ message })
  }
})
